var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "fab" } }, [
    _c("div", [
      _c(
        "ul",
        { staticClass: "parent" },
        _vm._l(_vm.fabs, function (f, i) {
          return _c(
            "li",
            { key: i, staticClass: "child", attrs: { value: f } },
            [
              _c("span", { staticClass: "justify-content-center" }, [
                _c(
                  "span",
                  { staticClass: "mr-1" },
                  [
                    _c("a-checkbox", {
                      staticClass: "mx-2 p-1",
                      on: {
                        change: function ($event) {
                          return _vm.fabInfoChanged()
                        },
                      },
                      model: {
                        value: f.enable,
                        callback: function ($$v) {
                          _vm.$set(f, "enable", $$v)
                        },
                        expression: "f.enable",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "ml-3" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t("message." + f.type + "FabListDescription")
                      ) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                f.type === "whatsapp"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              staticStyle: { gap: "5px" },
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.path, f.type)
                                },
                              },
                            },
                            [
                              _c("vue-country-code", {
                                staticClass:
                                  "col-3 country-code my-2 ml-2 mr-0",
                                staticStyle: { height: "32px" },
                                attrs: {
                                  enabledCountryCode: true,
                                  defaultCountry: f.country,
                                  preferredCountries: ["" + f.country],
                                },
                                on: {
                                  onSelect: function ($event) {
                                    return _vm.onSelect($event, f.type)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              f.path !== undefined
                                ? _c("a-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "(###)#######",
                                        expression: "'(###)#######'",
                                      },
                                    ],
                                    staticClass: "col-5 inputs my-2 mr-2 p-3",
                                    staticStyle: { "margin-left": "1px" },
                                    style: { border: _vm.activeBorderWP },
                                    attrs: {
                                      placeholder: _vm.$t("message.phone"),
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.path,
                                      callback: function ($$v) {
                                        _vm.$set(f, "path", $$v)
                                      },
                                      expression: "f.path",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t("message.sendNumber", {
                                    path: "+" + f.callingCode + f.path,
                                  }),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row text-center justify-content-center align-items-center",
                              staticStyle: { gap: "10px" },
                            },
                            [
                              f.text !== undefined
                                ? _c("a-textarea", {
                                    staticClass: "col-8 inputs m-2 ml-0 p-3",
                                    staticStyle: {
                                      position: "relative",
                                      width: "100%",
                                      height: "15vh",
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "message.typeYourMessage"
                                      ),
                                      maxlength: "300",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.text,
                                      callback: function ($$v) {
                                        _vm.$set(f, "text", $$v)
                                      },
                                      expression: "f.text",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourMessageDesc"
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "phone"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              staticStyle: { gap: "10px" },
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.tel, f.type)
                                },
                              },
                            },
                            [
                              _c("vue-country-code", {
                                staticClass:
                                  "col-3 country-code my-2 ml-2 mr-0",
                                staticStyle: { height: "32px" },
                                attrs: {
                                  enabledCountryCode: true,
                                  defaultCountry: f.country,
                                  preferredCountries: ["" + f.country],
                                },
                                on: {
                                  onSelect: function ($event) {
                                    return _vm.onSelect($event, f.type)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: f.tel,
                                    expression: "f.tel",
                                  },
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "(###)#######",
                                    expression: "'(###)#######'",
                                  },
                                ],
                                staticClass: "col-5 inputs my-2 mr-0 p-3",
                                staticStyle: {
                                  "margin-left": "1px",
                                  height: "32px",
                                },
                                style: { border: _vm.activeBorderPhone },
                                attrs: {
                                  placeholder: _vm.$t("message.phone"),
                                  autocomplete: "off",
                                  trim: "",
                                  type: "text",
                                },
                                domProps: { value: f.tel },
                                on: {
                                  blur: function ($event) {
                                    return _vm.fabInfoChanged(f.tel, f.type)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(f, "tel", $event.target.value)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t("message.callNumber", {
                                    phoneNumber: "+" + f.callingCode + f.tel,
                                  }),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "email"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              staticStyle: { gap: "120px" },
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.mail, f.type)
                                },
                              },
                            },
                            [
                              f.mail !== undefined
                                ? _c("a-input", {
                                    staticClass: "col-5 inputs my-2 mr-2 p-3",
                                    class: _vm.validInput,
                                    staticStyle: { "margin-left": "1px" },
                                    attrs: {
                                      placeholder: _vm.$t("message.email"),
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.mail,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.mail,
                                      callback: function ($$v) {
                                        _vm.$set(f, "mail", $$v)
                                      },
                                      expression: "f.mail",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t("message.email"),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row text-center justify-content-center align-items-center",
                            },
                            [
                              f.text !== undefined
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: f.text,
                                        expression: "f.text",
                                      },
                                    ],
                                    staticClass: "col-8 inputs m-2 ml-0 p-3",
                                    staticStyle: {
                                      position: "relative",
                                      width: "100%",
                                      height: "15vh",
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "message.typeYourMessage"
                                      ),
                                      maxlength: "300",
                                    },
                                    domProps: { value: f.text },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.mail,
                                          f.type
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(f, "text", $event.target.value)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourMessageMail"
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "facebook"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.path, f.type)
                                },
                              },
                            },
                            [
                              f.path !== undefined
                                ? _c("a-input", {
                                    staticClass: "col-8 inputs my-2 mr-2 p-3",
                                    staticStyle: { "margin-left": "1px" },
                                    attrs: {
                                      placeholder:
                                        "https://www.facebook.com/...",
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.path,
                                      callback: function ($$v) {
                                        _vm.$set(f, "path", $$v)
                                      },
                                      expression: "f.path",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourChannelLink",
                                    { channelLink: f.type }
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "twitter"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.path, f.type)
                                },
                              },
                            },
                            [
                              f.path !== undefined
                                ? _c("a-input", {
                                    staticClass: "col-8 inputs my-2 mr-2 p-3",
                                    staticStyle: { "margin-left": "1px" },
                                    attrs: {
                                      placeholder: "https://twitter.com/...",
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.path,
                                      callback: function ($$v) {
                                        _vm.$set(f, "path", $$v)
                                      },
                                      expression: "f.path",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourAccountLink",
                                    { accountLink: f.type }
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "instagram"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.path, f.type)
                                },
                              },
                            },
                            [
                              f.path !== undefined
                                ? _c("a-input", {
                                    staticClass: "col-8 inputs my-2 mr-2 p-3",
                                    staticStyle: { "margin-left": "1px" },
                                    attrs: {
                                      placeholder:
                                        "https://www.instagram.com/...",
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.path,
                                      callback: function ($$v) {
                                        _vm.$set(f, "path", $$v)
                                      },
                                      expression: "f.path",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourAccountLink",
                                    { accountLink: f.type }
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.type === "youtube"
                  ? _c("div", { staticClass: "mt-2 pt-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: f.enable === true,
                              expression: "f.enable === true",
                            },
                          ],
                          staticClass: "text-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex flex-row justify-content-center align-items-center text-center",
                              on: {
                                blur: function ($event) {
                                  return _vm.fabInfoChanged(f.path, f.type)
                                },
                              },
                            },
                            [
                              f.path !== undefined
                                ? _c("a-input", {
                                    staticClass: "col-8 inputs my-2 mr-2 p-3",
                                    staticStyle: { "margin-left": "1px" },
                                    attrs: {
                                      placeholder:
                                        "https://www.youtube.com/...",
                                      autocomplete: "off",
                                      trim: "",
                                      type: "text",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.fabInfoChanged(
                                          f.path,
                                          f.type
                                        )
                                      },
                                    },
                                    model: {
                                      value: f.path,
                                      callback: function ($$v) {
                                        _vm.$set(f, "path", $$v)
                                      },
                                      expression: "f.path",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("a-icon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "col-1 mx-3",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "var(--color-bg-primary-default)",
                                  "background-color": "#ffffff",
                                  "border-radius": "50%",
                                },
                                attrs: {
                                  content: _vm.$t(
                                    "message.typeYourChannelLink",
                                    { channelLink: f.type }
                                  ),
                                  theme: "filled",
                                  type: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }